import {
  Group,
  Stack,
  Text,
} from "@mantine/core";
import { useLanguage } from "../../../../../stores/LanguageStore";
import ContactListsListingTable from "./ContactListsListingTable";
import { useCampaignStore } from "../../../../../stores/CampaignStore";

const Contacts = ({setActive}) => {
  const lang = useLanguage((s) => s.language);
  const programData = useCampaignStore((s) => s.programData);
  const setProgramData = useCampaignStore((s) => s.setProgramData);

  const handleSelectionChange = (selectionModel) => {
    setProgramData({
      ...programData,
      contactlist_ids: selectionModel,
    });
  };
  

  return (
    <>
      {/* {isPast && (
        <Text c={"red"} ta={"center"} w={"100%"}>
          {lang.campaign.already_programmed}
        </Text>
      )} */}
      <Stack w={"85%"} mx={"auto"}>
        <Group mt={"xl"}>
          <Text fw={700} fz={24}>
            {lang.campaign.list_title}
          </Text>
        </Group>

        <ContactListsListingTable
          selectionModel={programData?.contactlist_ids}
          onSelectionChange={handleSelectionChange}
        />
        {/* <ContactListSelector
          size={"sm"}
          values={lists}
          onChange={(v) =>
            setProgramData({
              ...programData,
              contactlist_ids: v.map((x) => x.id),
            })
          }
          newItems={newItems}
          dropdownHeight={isPast ? 175 : 200}
          disabled={isPast}
          withCounts
        /> */}
      </Stack>

      {/* <Group justify="space-between" w={"85%"} mx={"auto"} mt={8}>
        <Button
          variant="light"
          size="lg"
          leftSection={<IconArrowLeft />}
          onClick={() => setActive("workflow")}
          // disabled={isPast}
        >
          Retour
        </Button>
        <Button
          // variant="light"
          size="lg"
          ml={"auto"}
          rightSection={<IconChevronRight />}
          onClick={() => document.getElementById("next-button").click()}
          disabled={programData?.contactlist_ids?.length === 0}
          justify="flex-end"
        >
          {lang.global.next}
        </Button>
      </Group> */}

      {/* <Modal
        opened={opened}
        onClose={close}
        size={"100%"}
        title={lang.contact_lists.import.methods.title}
      >
        <SimpleGrid cols={4} pt={10}>
          {getListMethod().map((item) => (
            <ListImportItem
              key={item.value}
              item={item}
              onClick={handleButtonClick}
            />
          ))}
        </SimpleGrid>
        <Group justify="end" mt={"md"}>
          <BackButton onClick={close} />
        </Group>
      </Modal> */}
    </>
  );
};

export default Contacts;
